module.exports = __webpack_public_path__ + "media/images/front/clinicbook_img_bl-d401d6062c86563f183fbaacbab17e35.png";